export const MODEL_URLS = 'modelUrls';
export const QUERY_KEY_IS_CONTEST = 'isContest';
export const PROJECTS_QUERY_KEY = 'projects';
